module.exports = __webpack_public_path__ + "static/media/app-store-apple.f1f91920.svg";